import React from 'react';
import { Data } from '@singularsystems/neo-core';
import { untracked } from 'mobx';
Data.DataViewBase.unTrackedSort = untracked;
var DataViewContextParams = /** @class */ (function () {
    function DataViewContextParams() {
    }
    return DataViewContextParams;
}());
export { DataViewContextParams };
export var DataViewContext = React.createContext(new DataViewContextParams());
